import Text from "@/components/common/Typography/Text"
import { Col, Row } from "antd"
import dayjs from "dayjs"
import { useEffect, useState } from "react"

let interval: any = null

const Timmer = ({ flashSale }: any) => {
  const [duration, setDuration] = useState(0)

  useEffect(() => {
    if (!flashSale) return;

    if (interval) {
      clearInterval(interval)
      interval = null
    }

    interval = setInterval(() => {
      const today = dayjs()
      const slotTime = flashSale.slotTime
      const [hour, min] = slotTime.endTime.split(':')
      const endTime = dayjs().set("hour", parseFloat(hour)).set('minute', parseFloat(min)).set("second", 0)
      const duration = endTime.diff(today, 'seconds')
      setDuration(duration)
    }, 1000)
  }, [flashSale])

  const hourDuration = duration / 3600

  const hour = Math.floor(hourDuration)
  const minsDuration = ((hourDuration - hour) * 60)
  const mins = Math.floor(minsDuration)
  const seconds = Math.floor((minsDuration - mins) * 60)

  return (
    <Row align='middle' className='home__deals-hotels--timmer' gutter={[5, 5]} wrap={false}>
      <Col>
        <Text>
          Chương trình sẽ kết thúc trong
        </Text>
      </Col>
      <Col>
        <Row gutter={[5, 5]} wrap={false}>
          <Col>
            <Row
              justify='center'
              className="home__deals-hotels--timmer-box home__deals-hotels--timmer-days"
            >
              {hour < 10 ? `0${hour}` : hour}
            </Row>
          </Col>
          <Col>
            <Row
              justify='center'
              className="home__deals-hotels--timmer-box home__deals-hotels--timmer-hours"
            >
              {mins < 10 ? `0${mins}` : mins}
            </Row>
          </Col>
          <Col>
            <Row
              justify='center'
              className="home__deals-hotels--timmer-box home__deals-hotels--timmer-minutes"
            >
              {seconds < 10 ? `0${seconds}` : seconds}
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default Timmer